import { get } from 'lodash';
import { apiClientInstance } from './axiosClient';
import { metricsApi } from './metricsApi';

const extractErrorMessage = err =>
    err.response
        ? get(err, 'response.data.message', 'Unknown error')
        : err.message;

// eslint-disable-next-line import/prefer-default-export
export const getTermsAndConditions = async () => {
    try {
        const { data } = await apiClientInstance.get(
            '/client/terms-and-conditions'
        );

        return {
            data: data || null,
            errorMessage: null
        };
    } catch (err) {
        const statusCode = get(err, 'response.status', 500);
        await metricsApi.errorMetric(
            'getTermsAndConditions',
            statusCode,
            extractErrorMessage(err)
        );

        return {
            data: null,
            errorMessage: extractErrorMessage(err)
        };
    }
};
